<template>
  <!-- 点検一覧検索 -->
  <div id="AppInspectionSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">点検検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div horizontal class="column is-one-third">
            <b-field label="点検期間" labelPosition="on-border">
              <b-datepicker
                v-model="startDate"
                name="startDate"
                type="month"
                placeholder="検索開始年月"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                  class="button is-danger"
                  @click="startDate = null,searchConditions.startDate= ''"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
              <b-datepicker
                v-model="endDate"
                name="endDate"
                type="month"
                placeholder="検索終了年月"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                  class="button is-danger"
                  @click="endDate = null,searchConditions.endDate= ''"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientCode"
                name="recipientCode"
                data-vv-as="患者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientName"
                name="recipientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="住所" labelPosition="on-border">
              <b-input
                v-model="searchConditions.address"
                name="address"
                data-vv-as="住所"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="シリアル" labelPosition="on-border">
              <b-input
                v-model="searchConditions.serialNumber"
                name="serialNumber"
                data-vv-as="シリアル"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--5行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="器械交換" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.machineReplaceGroup"
                id="check1"
                native-value="1"
              >有り</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.machineReplaceGroup"
                id="check0"
                native-value="0"
              >無し</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-two-third">
            <b-field label="点検種別" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="0"
              >院内/当社点検有</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="1"
              >院内/当社点検無し</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="2"
              >在宅/当社点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="3"
              >在宅/ディーラー点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="4"
              >院内・在宅/RR点検不要</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.inspectionKindGroup" native-value="5">社内器</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="6"
              >
                フリーメンテ
              </b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="99"
              >未設定</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-thirds">
            <b-field label="実施状況" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.inspectionStatusGroup"
                native-value="1"
              >アポ未実施</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionStatusGroup"
                native-value="2"
              >アポ実施済</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionStatusGroup"
                native-value="3"
              >点検中</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionStatusGroup"
                native-value="6"
              >点検完了</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionStatusGroup"
                native-value="5"
              >取り消し</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン -->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-button
              class="button is-primary has-text-centered"
              icon-left="marker-check"
              native-type="button"
              v-on:click="addAppointment"
              :disabled="checkedRows.length <= 0 || this.userInfo.roleId==2"
            >予約追加</b-button>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="account-switch"
              native-type="button"
              v-on:click="changeStaffs"
              :disabled="checkedRows.length <= 0|| this.userInfo.roleId==2"
            >点検担当者変更</b-button>
            <b-modal :active.sync="isStaffChangeModalActive" has-modal-card>
              <staffChange-modal v-on:staff-change-event="staffChanged" v-bind:item="null"></staffChange-modal>
            </b-modal>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="clipboard-check"
              native-type="button"
              v-on:click="changeInspectionKind"
              :disabled="checkedRows.length<=0 || this.userInfo.roleId==2"
            >点検種別一括変更</b-button>
            <b-modal :active.sync="isKindChangeModalActive" has-modal-card>
              <kindChange-modal v-on:kind-change-event="kindChanged"></kindChange-modal>
            </b-modal>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="download"
              native-type="button"
              v-on:click="downloadPlan"
            >ダウンロード</b-button>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="google-maps"
              :disabled="!checkedRows.length"
              native-type="button"
              position="is-right"
              v-on:click="doShowGoogleMapChecked"
            >地図表示</b-button>
          </div>

          <div class="column is-3">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>

        <div v-show="data.length > 0" class="columns" style="text-align:left;">
          <div class="column">
            <span
              style="margin-left:5px;font-weight: bold;"
            >[患者数] 院内 / 当社点検有：{{inHospitalInspectionCnt}}件、</span>
            <span style="margin-left:5px;font-weight: bold;">在宅 / 当社点検：{{homeInspectionCnt}}件</span>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="scheduledMonth"
            detailed
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="appointmentCode"
                label="予約番号"
                sortable
                centered
              >{{ props.row.appointmentCode }}</b-table-column>
              <b-table-column
                field="productName"
                label="品目名"
                sortable
                centered
              >{{ props.row.productName }}({{props.row.productCode}})</b-table-column>
              <b-table-column
                field="inspectionKind"
                label="種別"
                sortable
                centered
              >{{ props.row.inspectionKind | inspectionTypeFillter}}</b-table-column>
              <b-table-column
                field="machineReplace"
                label="器械交換"
                sortable
                centered
              >{{ props.row.machineReplace }}</b-table-column>
              <b-table-column
                field="inspectionOrder"
                label="点検指示内容"
                sortable
                centered
              >{{ props.row.inspectionOrder | inspectionOrderFilter}}</b-table-column>
              <b-table-column
                field="staffName"
                label="担当者"
                sortable
                centered
              >{{ props.row.staffName }}</b-table-column>
              <b-table-column
                field="patientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.patientName }}</b-table-column>
              <b-table-column
                field="patientZipCode"
                label="郵便番号"
                sortable
                centered
              >{{ props.row.patientZipCode }}</b-table-column>
              <b-table-column
                field="scheduledMonth"
                label="実施予定月"
                sortable
                centered
              >{{ props.row.scheduledMonth }}</b-table-column>
              <b-table-column field="status" label="実施状況" sortable centered>
                <span
                  :class="['tag',
                       {'is-success':props.row.status == 6},
                       {'is-danger':props.row.status == 1},
                       {'is-warning':props.row.status == 2},
                       {'is-warning':props.row.status == 3},
                       {'is-warning':props.row.status == 4},
                       {'is-dark':props.row.status == 5}
                  ]"
                >{{ props.row.status | inspectionStatusFillter }}</span>
              </b-table-column>

              <b-table-column field="shippingStatus" label="定期消耗品状況" sortable centered>
                <span v-if="props.row.inspectionKind!=2">-</span>
                <span
                  v-else
                  :class="['tag',
                       {'is-danger':props.row.shippingStatus == 0},
                       {'is-success':props.row.shippingStatus == 1},                       
                       {'is-info':props.row.shippingStatus == 2} ,
                       {'is-warning':props.row.shippingStatus == 3}                    
                  ]"
                >{{ props.row.shippingStatus | shippingStatusFillter }}</span>
              </b-table-column>
              <b-table-column
                field="completionDate"
                label="実施日時"
                sortable
                centered
              >{{ props.row.completionDate }}</b-table-column>
              <b-table-column field="configuration" label="詳細">
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="checkbox-multiple-blank-outline"
                  native-type="button"
                  v-on:click="refer(props.row.inspectionCode,props.row.productCode,props.row.patientCode,props.row.serial)"
                  v-if="props.row.status==6||userInfo.roleId==2"
                ></b-button>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="mdi mdi-cog"
                  native-type="button"
                  v-on:click="edit(props.row.inspectionCode,props.row.productCode,props.row.patientCode,props.row.serial)"
                  v-else
                ></b-button>
              </b-table-column>
              <b-table-column field="prescription" label="処方/点検値" centered>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="mdi mdi-cog"
                  native-type="button"
                  v-on:click="prescriptionEdit(props.row)"
                  v-if="props.row.status!=6 && props.row.status!=5 &&props.row.status!=3 && userInfo.roleId!=2"
                ></b-button>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="checkbox-multiple-blank-outline"
                  native-type="button"
                  v-on:click="prescriptionValueRefer(props.row)"
                  v-if="props.row.status!=6 && props.row.status!=3 && userInfo.roleId==2"
                ></b-button>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="checkbox-multiple-blank-outline"
                  native-type="button"
                  v-on:click="prescriptionRefer(props.row)"
                  v-if="props.row.status==6"
                ></b-button>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <div class="content">
                <table style="table-layout: fixed;">
                  <tr>
                    <th style="width:200px;">営業所名：</th>
                    <td>{{ props.row.officeCode|officeFilter(officeMaster)}}</td>
                  </tr>
                  <tr v-if="props.row.crossBorderOfficeCode">
                    <th>越境依頼先：</th>
                    <td>{{ props.row.crossBorderOfficeCode|officeFilter(officeMaster)}}</td>
                  </tr>
                  <tr v-if="props.row.patientName">
                    <th>患者名：</th>
                    <td>{{ props.row.patientName }}</td>
                  </tr>
                  <tr v-if="props.row.patientNameKana">
                    <th>患者名(カナ)：</th>
                    <td>{{ props.row.patientNameKana }}</td>
                  </tr>
                  <tr v-if="props.row.patientAddress">
                    <th>患者住所：</th>
                    <td>
                      〒{{props.row.patientZipCode}} {{ props.row.patientAddress }}
                      <b-field class="file" style="float:right">
                        <b-button
                          class="button is-primary has-text-centered"
                          icon-left="google-maps"
                          native-type="button"
                          v-on:click="doShowGoogleMap([
                              {
                                    'address': props.row.patientAddress,
                                    'name': props.row.patientName,
                                    'patientZipCode': props.row.patientZipCode,
                                }
                                ])"
                        ></b-button>
                      </b-field>
                    </td>
                  </tr>
                  <tr v-if="props.row.patientPhone">
                    <th>患者連絡先：</th>
                    <td>{{ props.row.patientPhone }}</td>
                  </tr>
                  <!-- TODO: -->
                  <tr>
                    <th>シリアル番号：</th>
                    <td
                      v-if="props.row.machineReplaceProductCode && props.row.machineReplaceProductCode!=props.row.productCode"
                    >{{ props.row.machineReplaceProductName }}({{props.row.machineReplaceSerialNumber }}) ⇒ {{props.row.productName}}({{props.row.serial }})</td>
                    <td
                      v-else-if="props.row.machineReplaceSerialNumber"
                    >{{props.row.productName}}({{ props.row.machineReplaceSerialNumber }} ⇒ {{props.row.serial}})</td>
                    <td v-else>{{props.row.productName}}({{ props.row.serial }})</td>
                  </tr>
                  <tr>
                    <th>点検担当者：</th>
                    <td>
                      {{ props.row.staffName }}
                      <b-button
                        style="float:right"
                        class="button is-primary has-text-centered"
                        icon-left="account-switch"
                        native-type="button"
                        v-if="props.row.status!=6"
                        v-on:click="changeStaff(props.row.inspectionCode,props.row.status,props.row.appointmentCode)"
                        position="is-right"
                        :disabled="userInfo.roleId == 2"
                      ></b-button>
                      <b-modal :active.sync="isStaffChangeModalActive" has-modal-card>
                        <staffChange-modal
                          v-on:staff-change-event="staffChanged"
                          v-bind:item="props.row"
                        ></staffChange-modal>
                      </b-modal>
                    </td>
                  </tr>
                  <tr v-if="props.row.hospitalName">
                    <th>医療機関名：</th>
                    <td>{{ props.row.hospitalName }}</td>
                  </tr>
                  <tr v-if="props.row.hospitalAddress">
                    <th>医療機関住所：</th>
                    <td>
                      〒{{props.row.hospitalZipCode}} {{ props.row.hospitalAddress }}
                      <b-field class="file" style="float:right">
                        <b-button
                          class="button is-primary has-text-centered"
                          icon-left="google-maps"
                          native-type="button"
                          v-on:click="doShowGoogleMap([
                                {
                                    'address': props.row.hospitalAddress,
                                    'name': props.row.hospitalName,
                                    'patientZipCode': props.row.hospitalZipCode,
                                }
                                ])"
                        ></b-button>
                      </b-field>
                    </td>
                  </tr>
                  <tr>
                    <th>点検報告書送付先：</th>
                    <td>
                      <div>
                        <template v-if="checkOkSendType(props.row.reportDestinationPatientForm)">
                          <span>〒{{props.row.patientZipCode}} {{ props.row.patientAddress }}</span>
                          <span
                            style="margin-left:10px"
                          >(患者/{{ props.row.reportDestinationPatientForm|sendTypeFillter }})</span>
                          <br />
                        </template>
                        <template v-if="checkOkSendType(props.row.reportDestinationHospitalForm)">
                          <span>〒{{props.row.hospitalZipCode}} {{ props.row.hospitalAddress }}</span>
                          <span
                            style="margin-left:10px"
                          >(医療機関/{{ props.row.reportDestinationHospitalForm | sendTypeFillter }})</span>
                          <br />
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="props.row.hospitalName">
                    <th>点検期間：</th>
                    <td>{{ props.row.inspectionSpan }}ヶ月</td>
                  </tr>
                  <tr>
                    <th>次回点検予定：</th>
                    <td>
                      {{ props.row.nextScheduledMonth }}
                      <b-button
                        v-if="showStartInspection(props.row)"
                        style="float: right; bottom: 0"
                        class="button is-primary has-text-centered"
                        icon-left="checkbox-multiple-marked-outline"
                        native-type="button"
                        v-on:click="startInspection(props.row)"
                      >
                        点検登録
                      </b-button>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </b-table>
          <b-modal :active.sync="isShowGoogleMap" has-modal-card>
            <googleMap-form v-bind:marker="addressList"></googleMap-form>
          </b-modal>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";
import MapTemplate from "./AppMapView";
import * as inspection from "../utils/inspection"

const ModalForm = {
  props: ["item"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();
      this.officeCode = staffInfo.officeCode;
      this.staffCode = staffInfo.staffCode;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      this.setStaffs(this.officeCode, this.staffCode, this.staffName);
    },
    setStaffs: function(officeCode, staffCode, staffName) {
      // 選択された担当者情報を親画面に返却
      this.$emit(
        "staff-change-event",
        officeCode,
        staffCode,
        staffName,
        this.$props.item
      );
      this.$parent.close();
    }
  },
  data() {
    return {
      officeMasterList: JSON.parse(
        sessionStorage.getItem("referenceEnableOffice")
      )
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-on:set-staff-event="setStaffs" v-bind:office-master-list="officeMasterList"/>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};
const kindChangeModal = {
  props: [],
  components: {},
  methods: {
    setKind: function() {
      //選択された点検種別を親画面に返却
      if (this.kind == "") {
        //複数選択の場合はメッセージ
        this.showErrorMessage("点検種別を選択してください。");
        return;
      }
      this.$emit("kind-change-event", this.kind);
      this.$parent.close();
    }
  },
  data() {
    return {
      kind: ""
    };
  },
  template: `<form action="">
              <div class="modal-card" style="width:800px;" >
                <header class="modal-card-head" >
                  <p class="modal-card-title" style="color:whitesmoke;" >点検種別一括変更</p>
                </header>
                <section class="modal-card-body" >
                  <template>
                    <div id="AppSelectKind" style="height:350px;" >
                      <div class="columnsis-vcentered" >
                      <!--点検種別選択-->
                        <div style="min-height:350px;width:100%;" >
                          <th>点検種別</th>
                          <b-select v-model="kind"name="inspectionKind"
                            data-vv-as="点検種別"
                            expanded>
                              <option value="0">院内/当社点検有</option>
                              <option value="1">院内/当社点検無し</option>
                              <option value="2">在宅/当社点検</option>
                              <option value="3">在宅/ディーラー点検</option>
                              <option value="4">院内・在宅/RR点検不要</option>
                              <option value="5">社内器</option>
                              <option value="6">フリーメンテ</option>
                            </b-select>
                        </div>
                      </div>
                    </div>
                  </template>
                </section>
                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="setKind">決定</button>
                  <button class="button" type="button" @click="$parent.close()">閉じる</button>
                </footer>
              </div>
            </form>`
};
const MapForm = {
  props: ["marker"],
  components: {
    maps: MapTemplate
  },
  template: `
      <maps :markers="marker" />
    `
};
export default {
  name: "AppInspectionSearch",
  methods: {
    checkOkSendType: function(value) {
      if (value == 3) {
        return false;
      }
      return true;
    },
    search: function(event) {
      this.checkedRows = [];
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.address) ||
        this.isLength(this.searchConditions.productCode) ||
        this.isLength(this.searchConditions.productName) ||
        this.isLength(this.searchConditions.serialNumber) ||
        this.searchConditions.machineReplaceGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0 ||
        this.searchConditions.inspectionStatusGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.startDate &&
          !this.endDate &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.recipientCode) &&
          !this.isLength(this.searchConditions.recipientName) &&
          !this.isLength(this.searchConditions.address) &&
          !this.isLength(this.searchConditions.productCode) &&
          !this.isLength(this.searchConditions.productName) &&
          !this.isLength(this.searchConditions.serialNumber)
        ) {
          if (
            this.isSearchAll(
              [this.searchConditions.machineReplaceGroup.length, 2],
              [this.searchConditions.inspectionKindGroup.length, 7],
              [this.searchConditions.inspectionStatusGroup.length, 5]
            )
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatMonth(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatMonth(this.endDate);
        }
        for (var a in this.searchConditions.inspectionKindGroup) {
          this.searchConditions.inspectionKindGroup[a] = parseInt(
            this.searchConditions.inspectionKindGroup[a]
          );
        }
        for (var b in this.searchConditions.inspectionStatusGroup) {
          this.searchConditions.inspectionStatusGroup[b] = parseInt(
            this.searchConditions.inspectionStatusGroup[b]
          );
        }
        if (this.searchConditions.machineReplaceGroup.length == 1) {
          this.searchConditions.machineReplace = parseInt(
            this.searchConditions.machineReplaceGroup[0]
          );
        }
        var excuteApi = this.getInspectionListPOST;
        var successCallBack = this.getInspectionListPOSTSuccess;
        var errorCallBack = this.getInspectionListPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
      }
    },
    getInspectionListPOST: function(client) {
      var req = {};
      if (this.searchConditions.machineReplaceGroup.length == 1) {
        req = {
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          recipientCode: this.searchConditions.recipientCode,
          recipientName: this.searchConditions.recipientName,
          address: this.searchConditions.address,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          serialNumber: this.searchConditions.serialNumber,
          machineReplace: this.searchConditions.machineReplace,
          inspectionType: this.searchConditions.inspectionKindGroup,
          status: this.searchConditions.inspectionStatusGroup
        };
      } else {
        req = {
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          recipientCode: this.searchConditions.recipientCode,
          recipientName: this.searchConditions.recipientName,
          address: this.searchConditions.address,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          serialNumber: this.searchConditions.serialNumber,
          inspectionType: this.searchConditions.inspectionKindGroup,
          status: this.searchConditions.inspectionStatusGroup
        };
      }
      return client.apis.apiInspection.getInspectionListPOST({
        body: req
      });
    },
    getInspectionListPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var a in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[a] =
          this.searchConditions.inspectionKindGroup[a] + "";
      }
      for (var b in this.searchConditions.inspectionStatusGroup) {
        this.searchConditions.inspectionStatusGroup[b] =
          this.searchConditions.inspectionStatusGroup[b] + "";
      }
      this.inHospitalInspectionCnt = this.data
        .filter(val => val.inspectionKind == 0)
        .filter(function(v1, i1, a1) {
          return (
            a1.findIndex(function(v2) {
              return v1.patientCode === v2.patientCode;
            }) === i1
          );
        }).length;
      this.homeInspectionCnt = this.data
        .filter(val => val.inspectionKind == 2)
        .filter(function(v1, i1, a1) {
          return (
            a1.findIndex(function(v2) {
              return v1.patientCode === v2.patientCode;
            }) === i1
          );
        }).length;
    },
    getInspectionListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      for (var a in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[a] =
          this.searchConditions.inspectionKindGroup[a] + "";
      }
      for (var b in this.searchConditions.inspectionStatusGroup) {
        this.searchConditions.inspectionStatusGroup[b] =
          this.searchConditions.inspectionStatusGroup[b] + "";
      }
    },
    addAppointment: async function(event) {
      var isSelectedStaff = false;
      var isSelectedPatient = false;
      var isCompleate = false;
      var isCancel = false;
      var isInspectionKind = false;
      let isOnlyHospital = true;
      let isOnlyHome = true;
      let isAnyHospital = false;
      let isAnyPatientAddress = false;
      var staff = this.checkedRows[0].staffName;
      var patient = this.checkedRows[0].patientCode;
      const hospitalName = this.checkedRows[0].hospitalName;
      const patientAddress = this.checkedRows[0].patientAddress;
      const patientZipCode = this.checkedRows[0].patientZipCode;
      if (this.checkedRows.length != 0) {
        // 選択行の患者,点検担当者判定処理
        for (var selected in this.checkedRows) {
          if (this.checkedRows[selected].status == 6) {
            // 点検完了の場合
            isCompleate = true;
            break;
          }
          if (this.checkedRows[selected].status == 5) {
            // 点検取り消しの場合
            isCancel = true;
            break;
          }
          if (
            this.checkedRows[selected].inspectionKind == null ||
            this.checkedRows[selected].inspectionKind == 1 ||
            this.checkedRows[selected].inspectionKind == 3 ||
            this.checkedRows[selected].inspectionKind == 4 ||
            this.checkedRows[selected].inspectionKind == 5 ||
            this.checkedRows[selected].inspectionKind == 6
          ) {
            // 点検種別が「院内/当社点検無し」,「在宅/ディーラー点検」,「院内・在宅/RR点検」,「社内器」,「フリーメンテ」,「null」
            isInspectionKind = true;
            break;
          }
          switch (this.checkedRows[selected].inspectionKind) {
            case inspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code: // 院内/当社点検有
              isOnlyHome = false;
              break;
            case inspection.INSPECTION_TYPE_MAP.homeMyCompany.code: // 在宅/当社点検
              isOnlyHospital = false;
              break;
            default:
              isOnlyHospital = false;
              isOnlyHome = false;
          }
          if (patient != this.checkedRows[selected].patientCode) {
            // 患者が異なる場合
            isSelectedPatient = true;
          }
          if (staff != this.checkedRows[selected].staffName) {
            // 担当者が異なる場合
            isSelectedStaff = true;
            break;
          }
          if (hospitalName != this.checkedRows[selected].hospitalName) {
            // 医療機関が異なる場合
            isAnyHospital = true;
          }
          if (patientAddress != this.checkedRows[selected].patientAddress || patientZipCode != this.checkedRows[selected].patientZipCode) {
            // 患者住所が異なる場合
            isAnyPatientAddress = true;
          }
        }
      }

      // 医療機関判定
      if (isOnlyHospital && isAnyHospital) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>(医療機関が同一である行のみ選択してください。)"
          );
          return;
      }

      // 患者住所判定
      if (isOnlyHome && isAnyPatientAddress) {
        this.showErrorMessage(
          "選択行に誤りがあります。<br>(患者住所が同一である行のみ選択してください。)"
        );
        return;
      }

      // 選択行に誤りが無い場合のみ、画面遷移
      if (
        !isSelectedStaff &&
        (!isSelectedPatient || isOnlyHospital || isOnlyHome) &&
        !isCompleate &&
        !isInspectionKind &&
        !isCancel
      ) {
        const patients = [];
        for (const checkedRow of this.checkedRows) {
          let patient = patients.find((elem) => elem.patientCode == checkedRow.patientCode);
          if (!patient) {
            patient = {
              patientName: checkedRow.patientName,
              patientCode: checkedRow.patientCode,
              patientZipCode: checkedRow.patientZipCode,
              patientAddress: checkedRow.patientAddress,
              patientPhone: checkedRow.patientPhone,
              products: [],
            };
            patients.push(patient);
          }
          const product = {
            productName: checkedRow.productName,
            productCode: checkedRow.productCode,
            serial: checkedRow.serial,
            machineReplace: checkedRow.machineReplace,
            inspectionOrder: checkedRow.inspectionOrder,
            inspectionKind: false,
          };
          patient.products.push(product);
        }

        //TODO:
        var sloffs = [];
        for (let i = 0; i < this.checkedRows.length; i++) {
          sloffs.push(this.checkedRows[i].officeCode);
        }

        // 重複を削除したリスト
        sloffs = sloffs.filter(function(x, i, target) {
          return target.indexOf(x) === i;
        });

        this.$router.push({
          name: "AppAppointmentEdit",
          params: {
            appointmentCode: "",
            status: "4",
            patients: patients,
            hospitalAddress: isOnlyHospital ? this.checkedRows[0].hospitalAddress : null,
            searchConditions: this.searchConditions,
            isCrossBorder: false,
            sloffs: sloffs
          }
        });
      } else {
        if (isCompleate) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>(点検完了済みでない行のみ選択してください。)"
          );
        }
        if (isCancel) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>(点検が取り消しでない行のみ選択してください。)"
          );
        }
        if (isSelectedStaff) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>(点検担当者が同一である行のみ選択してください。)"
          );
        }
        if (isSelectedPatient && !isOnlyHospital && !isOnlyHome) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>(患者情報が同一である行のみ選択してください。)"
          );
        }
        if (isInspectionKind) {
          this.showErrorMessage(
            "選択行に誤りがあります。<br>点検種別が下記以外のものを選択してください。<br>「院内/当社点検無し」<br>「在宅/ディーラー点検」<br>「院内・在宅/RR点検」<br>「社内器」<br>「フリーメンテ」<br>「種別なし」"
          );
        }
      }
    },
    changeStaff: function(code, status, appointmentCode) {
      // 点検担当者変更
      if (status != 6) {
        this.staffChangedInspectionCode = code;
        this.isStaffChangeModalActive = true;
      } else {
        // エラーメッセージ表示
        this.showErrorMessage(
          "点検完了済みの情報です。<br>担当者の変更はできません。"
        );
      }
    },
    changeStaffs: function(event) {
      // 点検担当者変更
      var flg = false;
      this.staffChangedInspectionCode = "";
      if (this.checkedRows.length > 0) {
        flg = true;
        for (var i = 0; i < this.checkedRows.length; i++) {
          if (this.checkedRows[i].status == 6) {
            // 点検完了が選択行に含まれている場合
            flg = false;
          }
        }
      }
      if (flg) {
        this.isStaffChangeModalActive = true;
      } else {
        // エラーメッセージ表示
        this.showErrorMessage(
          "点検完了済みの情報が含まれています。<br>再度選択を行ってください。"
        );
      }
    },
    changeInspectionKind: function(event) {
      //点検種別一括変更
      var flg = false;
      if (this.checkedRows.length > 0) {
        flg = true;
        for (var i = 0; i < this.checkedRows.length; i++) {
          if (this.checkedRows[i].status != 1) {
            //アポ未実施以外の場合、変更させない
            flg = false;
          }
        }
      }
      if (flg) {
        this.isKindChangeModalActive = true;
      } else {
        //エラーメッセージ表示
        this.showErrorMessage(
          "ステータス「アポ未実施」以外の情報が含まれています。<br>再度選択を行ってください。"
        );
      }
    },
    edit: function(inspectionCode, productCode, patientCode, serial) {
      // 詳細編集
      this.$router.push({
        name: "AppInspectionEdit",
        params: {
          inspectionCode: inspectionCode,
          productCode: productCode,
          patientCode: patientCode,
          serial: serial,
          searchConditions: this.searchConditions
        }
      });
    },
    refer: function(inspectionCode, productCode, patientCode, serial) {
      // 詳細参照
      this.$router.push({
        name: "AppInspectionView",
        params: {
          inspectionCode: inspectionCode,
          productCode: productCode,
          patientCode: patientCode,
          serial: serial,
          searchConditions: this.searchConditions
        }
      });
    },
    prescriptionEdit: function(data) {
      // 処方値編集
      this.$router.push({
        name: "AppPrescriptionEdit",
        params: {
          code: data.inspectionCode,
          productCode: data.productCode,
          productName: data.productName,
          patientCode: data.patientCode,
          patientName: data.patientName,
          serialNumber: data.serial,
          hospitalName: data.hospitalName,
          department: data.department,
          doctorName: data.doctorName,
          searchConditions: this.searchConditions,
          edit: true,
          refer: false,
          therapy: data.therapy,
          mainSetting: data.mainSetting,
        }
      });
    },
    prescriptionValueRefer: function(data) {
      // 処方値参照
      this.$router.push({
        name: "AppPrescriptionEdit",
        params: {
          code: data.inspectionCode,
          productCode: data.productCode,
          productName: data.productName,
          patientCode: data.patientCode,
          patientName: data.patientName,
          serialNumber: data.serial,
          hospitalName: data.hospitalName,
          department: data.department,
          doctorName: data.doctorName,
          searchConditions: this.searchConditions,
          edit: false,
          refer: true,
          therapy: data.therapy,
          mainSetting: data.mainSetting,
        }
      });
    },
    prescriptionRefer: function(data) {
      // 点検値参照
      this.$router.push({
        name: "AppPrescriptionView",
        params: {
          code: data.inspectionCode,
          productCode: data.productCode,
          patientCode: data.patientCode,
          productName: data.productName,
          serialNumber: data.serial,
          machineReplaceProductCode: data.machineReplaceProductCode,
          machineReplaceSerialNumber: data.machineReplaceSerialNumber,
          machineReplaceProductName: data.machineReplaceProductName,
          patientName: data.patientName,
          hospitalName: data.hospitalName,
          department: data.department,
          doctorName: data.doctorName,
          searchConditions: this.searchConditions,
          appointmentCode: data.appointmentCode,
          completionDate: data.completionDate,
          therapy: data.therapy,
          mainSetting: data.mainSetting,
        }
      });
    },
    staffChanged: function(officeCode, staffCode, staffName, info) {
      // 選択された担当者情報をモーダル画面から取得
      var list = [];
      if (this.staffChangedInspectionCode != "") {
        // 単一の担当者変更の場合
        list.push(info);
        this.changeTargetInfo = info;
      } else {
        // 複数選択の場合
        // 担当者変更対象行の情報を取得
        for (var i = 0; i < this.checkedRows.length; i++) {
          list.push(this.checkedRows[i]);
        }
      }
      // 担当者変更対象行の情報抽出
      var appointmentCode = [];
      var productCode = [];
      var patientCode = [];
      var serial = [];
      var oldStaffCode = [];
      list.forEach(function(val) {
        appointmentCode.push(val.appointmentCode);
        productCode.push(val.productCode);
        patientCode.push(val.patientCode);
        serial.push(val.serial);
        oldStaffCode.push(val.staffCode);
      });
      this.setInfo = {
        appointmentCode: appointmentCode,
        productCode: productCode,
        patientCode: patientCode,
        serial: serial,
        oldStaffCode: oldStaffCode,
        newStaffCode: staffCode,
        newStaffName: staffName,
        newOfficeCode: officeCode
      };

      // 変更内容をDBに設定
      var excuteApi = this.setChangedStaffPOST;
      var successCallBack = this.setChangedStaffPOSTSuccess;
      var errorCallBack = this.setChangedStaffPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setChangedStaffPOST: function(client) {
      var items = [];
      for (var i = 0; i < this.setInfo.productCode.length; i++) {
        items.push({
          appointmentCode: this.setInfo.appointmentCode[i],
          productCode: this.setInfo.productCode[i],
          patientCode: this.setInfo.patientCode[i],
          serial: this.setInfo.serial[i],
          oldStaffCode: this.setInfo.oldStaffCode[i],
          newStaffCode: this.setInfo.newStaffCode
        });
      }
      var obj = JSON.parse(JSON.stringify(items));
      return client.apis.apiInspection.setChangedStaffPOST({
        body: items
      });
    },
    setChangedStaffPOSTSuccess: function(result) {
      // 登録に成功した場合、変更内容を反映
      if (this.staffChangedInspectionCode != "") {
        // 単一の担当者変更の場合
        this.changeTargetInfo.staffCode = this.setInfo.newStaffCode;
        this.changeTargetInfo.staffName = this.setInfo.newStaffName;
      } else {
        // 複数選択の場合
        // 担当者変更対象行の情報を取得
        for (var i = 0; i < this.checkedRows.length; i++) {
          this.checkedRows[i].staffCode = this.setInfo.newStaffCode;
          this.checkedRows[i].staffName = this.setInfo.newStaffName;
        }
      }

      // 初期化
      this.setInfo = {};
      this.changeTargetInfo = {};
      this.staffChangedInspectionCodes = [];
      this.staffChangedInspectionCode = "";
      this.showSuccess(result);
    },
    setChangedStaffPOSTError: function(result) {
      // 登録に失敗した場合、変更内容を反映しない
      // エラーメッセージ表示
      this.showErrorMessage(result);
      // 初期化
      this.setInfo = {};
      this.staffChangedInspectionCodes = [];
      this.staffChangedInspectionCode = "";
    },
    kindChanged: function(kind) {
      //選択された担当者情報をモーダル画面から取得
      var list = [];
      let asvList = [];
      const MACHINE_TYPE_ASV = 13;
      const KIND_FREE_MAINTENANCE = 6;
      //点検種別一括変更対象行の情報を取得
      for (var i = 0; i < this.checkedRows.length; i++) {
        list.push(this.checkedRows[i]);
        if(this.checkedRows[i].machineType == MACHINE_TYPE_ASV){
          asvList.push(this.checkedRows[i]);
        }
      }

      if(kind == KIND_FREE_MAINTENANCE && list.length != asvList.length){
        // エラーメッセージ
        this.showErrorMessage(
          "フリーメンテはASVのみ設定可能です。<br>再度選択を行ってください。"
        );
        return;
      }

      //点検種別一括変更対象行の情報抽出
      var productCode = [];
      var patientCode = [];
      var serial = [];
      var inspectionKind = [];
      list.forEach(function(val) {
        productCode.push(val.productCode);
        patientCode.push(val.patientCode);
        serial.push(val.serial);
        inspectionKind.push(kind);
      });
      this.setInspectionKindInfo = {
        productCode: productCode,
        patientCode: patientCode,
        serial: serial,
        inspectionKind: inspectionKind
      };
      //変更内容をDBに設定
      var excuteApi = this.setChangedInspectionKindPOST;
      var successCallBack = this.setChangedInspectionKindPOSTSuccess;
      var errorCallBack = this.setChangedInspectionKindPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setChangedInspectionKindPOST: function(client) {
      var items = [];
      for (var i = 0; i < this.setInspectionKindInfo.productCode.length; i++) {
        items.push({
          productCode: this.setInspectionKindInfo.productCode[i],
          patientCode: this.setInspectionKindInfo.patientCode[i],
          serial: this.setInspectionKindInfo.serial[i],
          inspectionKind: this.setInspectionKindInfo.inspectionKind[i]
        });
      }
      var obj = JSON.parse(JSON.stringify(items));
      return client.apis.apiInspection.setChangedInspectionKindPOST({
        body: obj
      });
    },
    setChangedInspectionKindPOSTSuccess: function(result) {
      // 登録に成功した場合、変更内容を反映
      for (var i = 0; i < this.checkedRows.length; i++) {
        this.checkedRows[
          i
        ].inspectionKind = this.setInspectionKindInfo.inspectionKind[0];
      }
      // 初期化
      this.setInspectionKindInfo = {};
      this.showSuccess(result);
      // 再検索
      this.search();
    },
    setChangedInspectionKindPOSTError: function(result) {
      // 登録に失敗した場合、変更内容を反映しない
      // エラーメッセージ表示
      this.showErrorMessage(result);
      // 初期化
      this.setInspectionKindInfo = {};
    },
    downloadPlan: function(event) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.machineReplaceGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0 ||
        this.searchConditions.inspectionStatusGroup.length > 0
      ) {
        console.log("ダウンロード条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.startDate &
            !this.endDate &
            !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.recipientCode) &&
          !this.isLength(this.searchConditions.recipientName) &&
          !this.isLength(this.searchConditions.address)
        ) {
          if (
            this.isSearchAll(
              [this.searchConditions.machineReplaceGroup.length, 2],
              [this.searchConditions.inspectionKindGroup.length, 7],
              [this.searchConditions.inspectionStatusGroup.length, 5]
            )
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatMonth(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatMonth(this.endDate);
        }
        if (this.searchConditions.machineReplaceGroup.length == 1) {
          this.searchConditions.machineReplace = parseInt(
            this.searchConditions.machineReplaceGroup[0]
          );
        }

        var excuteApi = this.downloadInspectionResultTextFilePOST;
        var errorCallBack = this.downloadInspectionResultTextFilePOSTError;
        // Web Api Call
        this.downloadApiCall(excuteApi, errorCallBack);
      } else {
        console.log("ダウンロード条件未入力");
        this.showErrorMessage("ダウンロード条件を指定してください。");
        this.isSearchConditionAll = false;
      }
    },
    downloadInspectionResultTextFilePOST: function(client) {
      let req = {};
      var inspectionKindGroup = [];
      for (var a in this.searchConditions.inspectionKindGroup) {
        inspectionKindGroup.push(
          parseInt(this.searchConditions.inspectionKindGroup[a])
        );
      }
      var inspectionStatusGroup = [];
      for (var b in this.searchConditions.inspectionStatusGroup) {
        inspectionStatusGroup.push(
          parseInt(this.searchConditions.inspectionStatusGroup[b])
        );
      }

      req = {
        officeCode: this.searchConditions.officeCode,
        hospitalCode: this.searchConditions.hospitalCode,
        hospitalName: this.searchConditions.hospitalName,
        startDate: this.searchConditions.startDate,
        endDate: this.searchConditions.endDate,
        staffCode: this.searchConditions.staffCode,
        staffName: this.searchConditions.staffName,
        recipientCode: this.searchConditions.recipientCode,
        recipientName: this.searchConditions.recipientName,
        address: this.searchConditions.address,
        productCode: this.searchConditions.productCode,
        productName: this.searchConditions.productName,
        serialNumber: this.searchConditions.serialNumber,
        inspectionType: inspectionKindGroup,
        status: inspectionStatusGroup
      }
      if (this.searchConditions.machineReplaceGroup.length == 1) {
        req.machineReplace = this.searchConditions.machineReplace;
      }
      return client.apis.apiInspection.downloadInspectionResultTextFilePOST({
        body: req
      });
    },
    downloadInspectionResultTextFilePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    doShowGoogleMapChecked: function() {
      var address = [];
      for (var selected in this.checkedRows) {
        var target = {
          address: this.checkedRows[selected].patientAddress,
          name: this.checkedRows[selected].patientName,
          patientZipCode: this.checkedRows[selected].patientZipCode
        };
        address.push(target);
      }
      this.doShowGoogleMap(address);
    },
    doShowGoogleMap: function(address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },

    showStartInspection: function (row) {
      let res = false;
      // 種別=ディーラー点検かつ、実施状況=アポ未実施
      if (row.inspectionKind == inspection.INSPECTION_TYPE_MAP.homeDealer.code &&
          (row.status == inspection.INSPECTION_STATUS_MAP.noAppointment.code ||
          row.status == inspection.INSPECTION_STATUS_MAP.appointment.code ||
          row.status == inspection.INSPECTION_STATUS_MAP.underInspection.code)) {
        res = true;
      }
      return res;
    },
    startInspection: function(row) {
      this.selectedPatient = row;
      if (row.status == inspection.INSPECTION_STATUS_MAP.noAppointment.code) {
        // 予約登録
        let excuteApi = this.setAppointmentPOST;
        let successCallBack = this.setAppointmentPOSTSuccess;
        let errorCallBack = this.setAppointmentPOSTError;
        // WebAPI Call
        return this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        // 点検画面へ遷移
        let officeCode = JSON.parse(sessionStorage.getItem("userInfo")).officeCode;

        this.$router.push({
          name: "AppInspectionExecute",
          params: {
            appointmentCode: row.appointmentCode,
            staffCode: JSON.parse(sessionStorage.getItem("userInfo")).staffCode,
            staffName: JSON.parse(sessionStorage.getItem("userInfo")).fullName,
            patientName: row.patientName,
            patientCode: row.patientCode,
            officeName: this.getOfficeName(officeCode),
            officeCode: officeCode,
            searchConditions: this.searchConditions,
            isDealer: true,
            transitionSrc: "AppInspectionSearch",
          }
        });
      }

    },
    setAppointmentPOST: function(client) {
      let officeCode = this.selectedPatient.officeCode ? this.selectedPatient.officeCode : "";
      this.appointmentData.appointmentComment = "";
      // 越境依頼元
      this.appointmentData.crossBorderCofficeSrc = this.getOfficeName(officeCode);
      this.appointmentData.crossBorderCofficeSrcCode = officeCode;
      // 越境依頼先
      this.appointmentData.crossBorderCofficeTarCode = "";
      this.appointmentData.crossBorderCofficeTar = "";
      this.appointmentData.inspectionAddress = this.selectedPatient.patientAddress;
      this.appointmentData.patientCode = this.selectedPatient.patientCode;
      this.appointmentData.patientName = this.selectedPatient.patientName;
      this.appointmentData.patientAddress = this.selectedPatient.patientAddress;
      this.appointmentData.patientPhone = this.selectedPatient.patientPhone;
      this.appointmentData.patientZipCode = this.selectedPatient.patientZipCode;
      this.appointmentData.productList = [{
        inspectionKind: true,
        inspectionOrder: this.selectedPatient.inspectionOrder,
        machineReplace: this.selectedPatient.machineReplace,
        productCode: this.selectedPatient.productCode,
        productName: this.selectedPatient.productName,
        serial: this.selectedPatient.serial,
      }];
      this.appointmentData.status = 2;
      this.appointmentData.status = parseInt(this.appointmentData.status);
      this.appointmentData.staffName = "";
      this.appointmentData.staffCode = null;
      if (this.selectedPatient.appointmentCode != "-") {
        this.appointmentData.reservationId = this.selectedPatient.appointmentCode;
      }

      return client.apis.apiAppointment.setAppointmentPOST({ body: this.appointmentData });
    },
    setAppointmentPOSTSuccess: function(result) {
      let officeCode = JSON.parse(sessionStorage.getItem("userInfo")).officeCode;
      // 点検画面へ遷移
      this.$router.push({
        name: "AppInspectionExecute",
        params: {
          appointmentCode: String(result.obj.appointmentCode),
          staffCode: this.appointmentData.staffCode,
          staffName: this.appointmentData.staffName,
          patientName: this.appointmentData.patientName,
          patientCode: this.appointmentData.patientCode,
          officeName: this.getOfficeName(officeCode),
          officeCode: officeCode,
          searchConditions: this.searchConditions,
          isDealer: true,
          transitionSrc: "AppInspectionSearch",
        }
      });
    },
    setAppointmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getOfficeName: function(value) {
      var officeElement = this.officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
  },
  data() {
    var data = [];
    var setInfo = {};
    var setInspectionKindInfo = {};
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var changeTargetInfo;
    var inHospitalInspectionCnt = 0;
    var homeInspectionCnt = 0;
    var searchConditions = {
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      startDate: "",
      endDate: "",
      staffCode: "",
      staffName: "",
      recipientCode: "",
      recipientName: "",
      address: "",
      productCode: "",
      productName: "",
      serialNumber: "",
      machineReplaceGroup: [],
      inspectionKindGroup: [],
      inspectionStatusGroup: []
    };
    var startDate = null;
    var endDate = null;
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.startDate == "string" &&
        searchConditions.startDate != ""
      ) {
        startDate = this.parseDateMonth(searchConditions.startDate);
      }
      if (
        typeof searchConditions.endDate == "string" &&
        searchConditions.endDate != ""
      ) {
        endDate = this.parseDateMonth(searchConditions.endDate);
      }
    } else {
      if (userInfo.roleId != 1 && userInfo.roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
        searchConditions.inspectionStatusGroup = ["1", "2", "3"];
      }
    }
    return {
      data,
      setInfo,
      setInspectionKindInfo,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      defaultOpenedDetails: [1],
      currentPage: 1,
      perPage: 10,
      checkedRows: [],
      isStaffChangeModalActive: false,
      isKindChangeModalActive: false,
      staffChangedInspectionCode: "",
      staffChangedInspectionCodes: [],
      searchConditions,
      startDate,
      endDate,
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      isShowGoogleMap: false,
      addressList: [],
      officeMaster,
      userInfo,
      inHospitalInspectionCnt,
      homeInspectionCnt,
      selectedPatient: {},
      appointmentData: {},
    };
  },
  filters: {},
  components: {
    "staffChange-modal": ModalForm,
    "kindChange-modal": kindChangeModal,
    "googleMap-form": MapForm
  },
  mounted: function() {
    //サイドメニューから遷移時は初期検索をしない
    if (this.$route.params["searchConditions"]) {
      this.search();
    }
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AppInspectionSearch.vue